(ns minorodata.app.posthog-events)

(def events
  {:source/created                "source_created"
   :extract/run-triggered         "extract_run_triggered"
   :extract/edited                "extract_edited"
   :extract/schedule-updated      "extract_schedule_updated"

   :transform/run-triggered       "transform_run_triggered"
   :transform/created             "transform_created"
   :transform/group-created       "transform_group_created"
   :transform/updated             "transform_updated"
   :transform/scheduled           "transform_scheduled"
   :transform/schedule-updated    "transform_schedule_updated"
   :transform/search-performed    "transform_search_performed"

   :transform-environment/selected    "transform_environment_selected"
   :transform-environment/created     "transform_environment_created"
   :transform-environment/deleted     "transform_environment_deleted"
   :transform-environment/compared    "transform_environment_compared"
   :transform-environment/merged      "transform_environment_merged"
   :transform-environment/data-copied "transform_environment_data_copied"

   :data-view/exported            "data_view_exported"
   :data-model/run-triggered      "data_model_run_triggered"

   :global-search/performed       "global_search_performed"
   :global-search/result-selected "global_search_result_selected"

   :sandbox/transform-created     "sandbox_transform_created"
   :sandbox/transform-updated     "sandbox_transform_updated"
   :sandbox/transform-stashed     "transform_stashed"
   :sandbox/transform-committed   "transform_committed"
   :sandbox/sync                  "sandbox_sync"
   :sandbox/reset                 "sandbox_reset"
   :sandbox/add-unit-test         "sandbox_add_unit_test"
   :sandbox/version-loaded        "sandbox_version_loaded"

   :pipeline/view-setting-toggled       "pipeline_view_setting_toggled"
   :pipeline/summary-panel-toggled      "pipeline_summary_panel_toggled"
   :pipeline/execution-timeline-opened  "pipeline_execution_timeline_opened"
   :pipeline/group-filter-toggled       "pipeline_group_filter_toggled"

   :logs/filtered                 "logs_filtered"
   :logs/details-viewed           "log_details_viewed"

   :overview/tab-selected         "overview_tab_selected"
   :overview/action-clicked       "overview_action_clicked"

   :kai/panel-mode-changed        "kai_panel_mode_changed"
   :kai/model-selector-opened     "kai_model_selector_opened"
   :kai/model-selected            "kai_model_selected"
   :kai/message-sent              "kai_message_sent"

   :byol/toggled                  "byol_toggled"
   :byol/key-submitted            "byol_key_submitted"
   :byol/key-removed              "byol_key_removed"
   :byol/default-provider-changed "byol_default_provider_changed"
   :byol/default-model-changed    "byol_default_model_changed"
   :byol/model-picker-toggled     "byol_model_picker_toggled"
   :byol/approved-models-updated  "byol_approved_models_updated"

   :keyboard-shortcuts/modal-opened "keyboard_shortcuts_modal_opened"
   :keyboard-shortcuts/used         "keyboard_shortcut_used"})
